import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LayoutWithNavbar from './LayoutWithNavbar';
import { fetchDebitDetailsByGstid,markDebitAsRemoved } from '../services/api';
import { FaEnvelope, FaFileExcel, FaTrash} from 'react-icons/fa';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const DebitDetailPage = () => {
  const { gstid } = useParams();
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    const loadDetails = async () => {
      const res = await fetchDebitDetailsByGstid(gstid);
      if (res.success) setInvoices(res.data.debit_note_details || []);
      else alert(res.message || 'Failed to fetch invoice details');
    };
    loadDetails();
  }, [gstid]);

  const handleRemoveInvoice = async (invoice_id) => {
    if (!window.confirm("Are you sure you want to remove this invoice?")) return;
  
    const res = await markDebitAsRemoved(invoice_id);
    if (res.success) {
      alert(res.message);
      const refreshed = await fetchDebitDetailsByGstid(gstid);
      if (refreshed.success) setInvoices(refreshed.data.debit_note_details || []);
    } else {
      alert(res.message);
    }
  };

  const handleExport = () => {
    if (!invoices.length) return alert("No data to export");

    const exportData = invoices.map(inv => ({
      Company: inv.company_name,
      "Trans No": inv.trans_no,
      "Ref No": inv.ref_no,
      "Ref Date": inv.ref_date,
      "Invoice Date": inv.invoice_date,
      "Taxable Value": inv.taxable_value,
      CGST: inv.cgst,
      SGST: inv.sgst,
      IGST: inv.igst,
      "Net Amount": inv.net_amount,
      Month: inv.month,
      Branch: inv.branch,
      "Overdue Days": inv.overdue_days
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Invoices");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Debit_Note_Details.xlsx");
  };

  return (
    <LayoutWithNavbar>
      <div style={styles.container}>
        <h2 style={styles.heading}>Debit Note Details</h2>

        <div style={{ textAlign: 'right', marginBottom: '10px' }}>
          <button onClick={handleExport} style={{ ...styles.exportButton }}>
            <FaFileExcel style={{ marginRight: '8px' }} /> Export as Excel
          </button>
        </div>

        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                {['Company', 'Trans No', 'Ref No', 'Ref Date', 'Invoice Date', 'Taxable Value', 'CGST', 'SGST', 'IGST', 'Net Amount', 'Month', 'Branch', 'Overdue Days', 'Action'].map((col, i) => (
                  <th key={i} style={styles.th}>{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {invoices.map((inv, i) => (
                <tr key={i} style={styles.tr}>
                  <td style={styles.td}>{inv.company_name}</td>
                  <td style={styles.td}>{inv.trans_no}</td>
                  <td style={styles.td}>{inv.ref_no}</td>
                  <td style={styles.td}>{inv.ref_date}</td>
                  <td style={styles.td}>{inv.invoice_date}</td>
                  <td style={styles.td}>{inv.taxable_value}</td>
                  <td style={styles.td}>{inv.cgst}</td>
                  <td style={styles.td}>{inv.sgst}</td>
                  <td style={styles.td}>{inv.igst}</td>
                  <td style={styles.td}>{inv.net_amount}</td>
                  <td style={styles.td}>{inv.month}</td>
                  <td style={styles.td}>{inv.branch}</td>
                  <td style={styles.td}>{inv.overdue_days}</td>
                  <td style={styles.td}>
                  <td style={styles.td}>
                    <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
                      <button
                        style={{ ...styles.iconButton, backgroundColor: '#dc3545' }}
                        onClick={() => handleRemoveInvoice(inv.id)}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>

                </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </LayoutWithNavbar>
  );
};

const styles = {
  container: {
    padding: '30px',
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    fontFamily: 'Segoe UI, sans-serif'
  },
  heading: {
    fontSize: '24px',
    fontWeight: '600',
    marginBottom: '20px'
  },
  tableWrapper: {
    overflowX: 'auto',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 0 10px rgba(0,0,0,0.04)'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    minWidth: '1000px'
  },
  th: {
    padding: '12px',
    backgroundColor: '#343a40',
    color: '#fff',
    fontWeight: '500',
    textAlign: 'left',
    borderBottom: '1px solid #dee2e6'
  },
  tr: {
    transition: 'background-color 0.2s',
  },
  td: {
    padding: '12px',
    borderBottom: '1px solid #dee2e6',
    fontSize: '14px',
    backgroundColor: '#fff'
  },
  iconButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px 10px',
    fontSize: '14px',
    backgroundColor: '#ffc107',
    color: '#000',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer'
  },
  exportButton: {
    padding: '10px 16px',
    fontSize: '16px',
    fontWeight: '600',
    backgroundColor: '#28a745',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer'
  }
};

export default DebitDetailPage;
